<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="showTaxStatusModal"
                   :data="model"
                   :title="$t('Tax Status')"
                   @show="onShow"
                   size="sm"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable>
      <input-widget :label="false"
                    :model="model"
                    attribute="tax_status_uuid"
                    type="select2"
                    display-field="${item.name}"
                    :items="taxStatuses"/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import TaxStatusForm from "../../../models/TaxStatusForm.model";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "TaxStatusModal",
    components: {InputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new TaxStatusForm({}),
        showConfirmation: false,
        oldTaxStatusUuid: null,
      }
    },
    methods: {
      ...mapActions(['toggleTaxStatusModal', 'saveTermsPartialData']),
      async onSubmit() {
        if (this.model.tax_status_uuid === this.oldTaxStatusUuid) {
          this.showConfirmation = false;
          this.toggleTaxStatusModal(false);
          return true
        }

        let success = await this.$confirm(this.$i18n.t('Modifying the tax status for a customer will impact the tax status of all future inventory items that are created under the receipts of this customer. Are you sure you want to proceed?'))
        if (!success) {
          return false
        }


        this.loading = true;
        let response = await this.saveTermsPartialData({tax_status_uuid: this.model.tax_status_uuid});
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.toggleTaxStatusModal(false);
          this.$toast('success', this.$t('Tax Status was successfully saved'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      onShow() {
        this.showConfirmation = true;
        this.oldTaxStatusUuid = this.taxStatusUuid
        this.model = new TaxStatusForm({tax_status_uuid: this.taxStatusUuid});
      },
      onHidden() {
        this.model = new TaxStatusForm();
        this.oldTaxStatusUuid = null
        this.toggleTaxStatusModal(false);
      },
    },
    watch: {
      taxStatusUuid() {
        this.model = new TaxStatusForm({tax_status_uuid: this.taxStatusUuid});
      }
    },
    computed: {
      ...globalMapState(['taxStatuses']),
      ...mapState({
        showTaxStatusModal: state => state.termsData.showTaxStatusModal,
        taxStatusUuid: state => state.termsData.tax_status_uuid
      }),
    },
  }
</script>

<style lang="scss" scoped>
</style>

